import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import {
  ListGeofenceStyleModel,
  useListGeofenceStylesQuery,
} from '@casops/store/apis/geofenceStylesApi';
import { useMemo } from 'react';

export const useStyleOptions = (): DropdownItemProps<number>[] => {
  const { data: styles } = useListGeofenceStylesQuery(undefined, {
    refetchOnMountOrArgChange: 120,
  });

  return useMemo<DropdownItemProps<number>[]>(() => {
    if (typeof styles !== 'undefined') {
      return styles.map(({ id, name }: ListGeofenceStyleModel) => ({
        key: id.toString(),
        value: id,
        stringValue: id.toString(),
        label: name,
      }));
    }
    return [];
  }, [styles]);
};

export default useStyleOptions;
